module.exports = __webpack_public_path__ + "img/spain-stomach-cancer-male.e8a93580.png";